import { useLoadGalleryImages } from "../../hooks/useLoadImages";
import ImageRender from "../../widgets/image-render/ImageRender";

function RenderImages({ classname }: { classname: string }) {
  const images = useLoadGalleryImages();
  
  return (
    <>
      {Object.entries(images)?.map(([key, value]) => {
        return (
          <ImageRender
            path={value}
            name={key}
            classname={classname}
            key={key}
          />
        );
      })}
    </>
  );
}

export default RenderImages;
